module.exports = __webpack_public_path__ + "img/gq.384854c0.svg";